import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const NewBlockStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  justify-content: space-between;
  border: 2px solid ${VARIABLES.COLORS.GRAY_2};
  border-radius: 2px;
  padding: 20px 20px 20px 35px;
  margin-bottom: 18px;
  min-height: 225px;
  cursor: pointer;
  flex-grow: 1;
  gap: 30px;
  /* Child element styles
  ------------------------------- */
  a {
    text-decoration: none;
    color: inherit;
  }

  h5 {
    color: ${VARIABLES.COLORS.BLUE_1};
    margin-bottom: 12px;
    display: -webkit-box;
    max-height: 75px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
  }

  p {
    color: ${VARIABLES.COLORS.GRAY_3};
    max-height: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .center-cropped {
    max-width: 244px;
    height: 184px;
    background-position: center center;
    background-repeat: no-repeat;
    overflow: hidden;
    border-radius: 6px;
    background-color: ${VARIABLES.COLORS.WHITE};
    background-size: 100%;
    display: flex;
    flex: none;

    img {
      min-height: 100%;
      min-width: 100%;
      /* opacity: 1; */
    }
  }

  .card-meta {
    display: flex;
    color: ${VARIABLES.COLORS.GRAY_10};
    margin-bottom: 12px;
  }

  .time {
    position: relative;
    margin-left: 15px;
    padding-left: 15px;

    &:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      margin-right: 15px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background-color: ${VARIABLES.COLORS.GRAY_10};
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  /* Start max-width: '1439px'*/
  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    padding: 20px;

    .center-cropped {
      max-width: 159px;
      max-height: 120px;
    }
  }
`
